import React from "react";
import DrumMachine from "./DrumMachine";

export default function App() {
  return (
    <div className="app-container">
      <DrumMachine />
    </div>
  );
}
